import { flaskApiFetch } from '~/auth/flask-api';

import type { CreateClientConfig } from './generated/client.gen';

export const createClientConfig: CreateClientConfig = (config) => {
  return {
    ...config,
    baseUrl: '',
    fetch: flaskApiFetch,
  };
};
